import React, { useEffect, useRef, useState } from 'react';
import { Chart as ChartJS, defaults } from 'chart.js/auto';
import { Chart } from 'react-chartjs-2';
import { Button, Card, Col, Form, Modal, Row, Spin, Tooltip, Typography } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import CustomSelect from './CustomSelect';
import { dataToOptionSelect, formatNumber } from '../utils/utility';

defaults.maintainAspectRatio = false;
defaults.responsive = true;

defaults.plugins.title.display = true;
defaults.plugins.title.align = 'start';
defaults.plugins.title.font.size = 20;
defaults.plugins.title.color = 'black';

BieuDo.propTypes = {
  apiCallBack: PropTypes.func.isRequired,
  whereCondition: PropTypes.object.isRequired,
  dataDimensions: PropTypes.array,
  dataMetrics: PropTypes.array,
  isModalOpen: PropTypes.bool,
  setIsModalOpen: PropTypes.func,
};

export default function BieuDo(props) {
  const [listGraphical, setListGraphical] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const { apiCallBack, whereCondition, dataDimensions, dataMetrics, isModalOpen, setIsModalOpen } = props;

  const [fields, setFields] = useState([
    { metricId: 1, dimensionId: -1 },
    { metricId: 2, dimensionId: -1 },
  ]);

  const [formModal] = Form.useForm();

  useEffect(() => {
    if (!whereCondition) {
      return;
    }

    async function getDefaultGraphical() {
      setIsLoading(true);
      const listDataGraphical = [];
      for (const item of fields) {
        const metricId = item?.metricId;
        const dimensionId = item?.dimensionId;
        const newWhereCondition = {
          ...whereCondition,
          metric_ids: metricId ? [metricId] : [],
          dimension_ids: dimensionId > 0 ? [dimensionId] : [],
        };
        const dataGraphical = await apiCallBack(newWhereCondition);
        listDataGraphical.push({
          metricId: metricId,
          dimensionId: dimensionId,
          dataGraphical: convertGraphical(dataGraphical?.data),
        });
      }

      setListGraphical(listDataGraphical);
      setIsLoading(false);
    }

    getDefaultGraphical();
  }, [whereCondition]);

  async function getNewGraphical(metricId, dimensionId) {
    const newWhereCondition = {
      ...whereCondition,
      metric_ids: [metricId],
      dimension_ids: dimensionId > 0 ? [dimensionId] : [],
    };

    return await apiCallBack(Object.assign({}, newWhereCondition ? newWhereCondition : {}));
  }

  const chartRefs = useRef([]);
  const [colors, setColors] = useState([
    '#0d6efd',
    '#6610f2',
    '#d63384',
    '#dc3545',
    '#fd7e14',
    '#ffc107',
    '#198754',
    '#20c997',
    '#0dcaf0',
    '#6f42c1',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
    '#3337FF',
    '#FF5733',
    '#FFBD33',
    '#FF3392',
    '#33FF57',
    '#33BFFF',
  ]);

  function getRandomColor() {
    var letters = '0123456789abcdef';
    var color = '#';
    var colorss = [...colors];
    while (colorss.includes(color) || color === '#') {
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
    }

    colorss.push(color);
    setColors(colorss);
    return color;
  }

  function convertGraphical(unprocessedData) {
    if (unprocessedData) {
      let dataChart = { datasets: [], labels: [], total: [] };
      if (!unprocessedData?.data) {
        return;
      }

      for (let i = 0; i < unprocessedData?.data?.length; i++) {
        var dataPoints = [];
        var oldVal = -1;
        for (let j = 0; j < unprocessedData?.data[i]?.data?.length; j++) {
          const value = unprocessedData.data[i].data[j];
          const dateString = value.date;
          const dateParts = dateString.split('/');
          if (oldVal !== dateParts[dateParts.length - 1]) {
            oldVal = dateParts[dateParts.length - 1];
          } else dateParts.pop();
          const date = dateParts.join('/');
          if (i === 0) {
            dataChart.labels.push(date);
          }
          dataPoints.push({ x: date, y: `${Number(value.value)}` });
        }
        dataChart.datasets.push({
          label: unprocessedData?.data[i]?.name?.toString(),
          backgroundColor: i < colors?.length ? colors[i] : getRandomColor(),
          borderColor: i < colors?.length ? colors[i] : getRandomColor(),
          data: dataPoints,
          isVisible: true,
        });
      }

      dataChart.total = unprocessedData?.total;

      return dataChart;
    }
  }

  async function changeField(type, index, value) {
    setIsLoading(true);
    let tmpFields = [...fields];

    if (type === 'metric') {
      tmpFields[index] = { metricId: value, dimensionId: tmpFields[index].dimensionId };
    } else {
      tmpFields[index] = { metricId: tmpFields[index].metricId, dimensionId: value };
    }

    setFields(tmpFields);

    let tempGraphical = [...listGraphical];

    const graphical = await getNewGraphical(tmpFields[index].metricId, tmpFields[index].dimensionId);

    tempGraphical[index] = {
      metricId: tmpFields[index].metricId,
      dimensionId: tmpFields[index].dimensionId,
      dataGraphical: convertGraphical(graphical?.data),
    };

    setListGraphical(tempGraphical);
    setIsLoading(false);
  }

  const handleSubmitFormModal = async (values) => {
    setIsLoading(true);
    let tempFields = [...fields];
    tempFields.push({ metricId: values?.metric, dimensionId: values?.dimension });
    setFields(tempFields);
    setIsModalOpen(false);
    formModal.resetFields();

    const graphical = await getNewGraphical(values?.metric, values?.dimension);
    let tempGraphical = [...listGraphical];
    tempGraphical.push({
      metricId: values?.metric,
      dimensionId: values?.dimension,
      dataGraphical: convertGraphical(graphical?.data),
    });
    setListGraphical(tempGraphical);
    setIsLoading(false);
  };

  const handleDeleteGraphical = (index) => {
    const tempFields = [...fields];
    setFields(tempFields.filter((_, i) => i !== index));
    const tempGraphical = [...listGraphical];
    setListGraphical(tempGraphical.filter((_, i) => i !== index));
  };

  const handleLegendClick = (itemLineChartIndex, itemIndex) => {
    const chart = chartRefs.current[itemLineChartIndex];
    if (!chart) return;

    const meta = chart.getDatasetMeta(itemIndex);
    meta.hidden = meta.hidden === null ? !chart.data.datasets[itemIndex].hidden : null;
    const listGraphicalTemp = [...listGraphical];
    listGraphicalTemp[itemLineChartIndex].dataGraphical.datasets = listGraphicalTemp[
      itemLineChartIndex
    ].dataGraphical.datasets.map((dataset, index) => {
      if (index === itemIndex) {
        return { ...dataset, isVisible: !dataset.isVisible };
      } else {
        return dataset;
      }
    });
    setListGraphical(listGraphicalTemp);
    chart.update();
  };

  const renderGraphical = () =>
    listGraphical?.map((item, indexLineChart) => {
      const span = listGraphical.length % 2 === 1 && indexLineChart === listGraphical.length - 1 ? 24 : 12;

      return (
        <Col key={indexLineChart} xs={24} xl={span}>
          <div className="flex flex-col justify-end h-full gap-2">
            {indexLineChart !== 0 && (
              <div>
                <Button
                  danger
                  onClick={() => {
                    handleDeleteGraphical(indexLineChart);
                  }}
                >
                  <CloseOutlined />
                  Xoá
                </Button>
              </div>
            )}
            <Card className={`flex flex-col shadow-sm rounded-md h-full ${indexLineChart === 0 ? 'mt-12' : ''}`}>
              <div className="grid grid-cols-2 items-center gap-4">
                <div className="flex items-center gap-2 w-full">
                  <Typography.Text className="w-18 whitespace-nowrap">Metrics</Typography.Text>
                  <CustomSelect
                    allowClear={false}
                    onChange={(value) => {
                      changeField('metric', indexLineChart, value);
                    }}
                    options={dataToOptionSelect(dataMetrics || [])}
                    value={item?.metricId}
                    className="flex-1"
                  />
                </div>

                <div className="flex items-center gap-2 w-full">
                  <Typography.Text className="w-18 whitespace-nowrap">Dimension</Typography.Text>

                  <CustomSelect
                    allowClear={false}
                    onChange={(value) => {
                      changeField('dimension', indexLineChart, value);
                    }}
                    options={[
                      { label: 'Tất cả', value: -1 },
                      ...dataToOptionSelect(dataDimensions?.filter((d) => d.id !== 1) || []),
                    ]}
                    value={item?.dimensionId}
                    className="flex-1"
                  />
                </div>
              </div>

              <div className="flex flex-row w-full">
                <div className="w-full h-[30em] flex-1">
                  <Chart
                    ref={(el) => (chartRefs.current[indexLineChart] = el)}
                    type="line"
                    data={{
                      labels: item?.dataGraphical?.labels,
                      datasets: item?.dataGraphical?.datasets,
                    }}
                    options={{
                      elements: {
                        line: {},
                      },
                      responsive: true,
                      maintainAspectRatio: false,
                      aspectRatio: 2,
                      stacked: true,
                      plugins: {
                        title: {
                          display: true,
                        },
                        legend: {
                          display: false,
                          position: 'right',
                          labels: {
                            boxWidth: 10,
                            boxHeight: 10,
                            fontSize: 10,
                            padding: 10,
                          },
                        },
                        tooltip: {
                          enabled: true,
                          mode: 'nearest',
                          intersect: true,
                        },
                      },
                      scales: {
                        y: {
                          beginAtZero: true,
                        },
                      },
                    }}
                  />
                </div>
                <div className="flex flex-col max-h-[22em] mt-[3em] min-w-8 w-40 max-w-52 overflow-y-auto">
                  {item &&
                    item?.dataGraphical &&
                    item?.dataGraphical?.datasets?.map((legend, indexLegend) => {
                      return (
                        <Tooltip placement="topLeft" title={legend?.label} key={indexLegend}>
                          <div
                            className="flex flex-row justify-start items-center gap-1 hover:cursor-pointer"
                            onClick={() => handleLegendClick(indexLineChart, indexLegend)}
                          >
                            <div
                              className={`min-w-3 min-h-3`}
                              style={{ backgroundColor: `${legend?.backgroundColor}` }}
                            ></div>

                            <span
                              className={`text-ellipsis whitespace-nowrap overflow-x-hidden ${
                                !legend?.isVisible ? 'line-through' : ''
                              }`}
                            >
                              {legend?.label}
                            </span>
                          </div>
                        </Tooltip>
                      );
                    })}
                </div>
              </div>
              <div className="grid grid-cols-3 gap-x-4 gap-y-2 overflow-auto mt-2 border-t pt-2 max-h-[20em]">
                {item &&
                  item?.dataGraphical &&
                  item?.dataGraphical?.total &&
                  item?.dataGraphical?.total.map((item1, index1) => {
                    return (
                      <div key={index1} className="flex flex-row justify-start gap-2 items-start break-all">
                        {item1.name}: {`${formatNumber(item1?.value)} ${item?.unit ?? ''}`}
                      </div>
                    );
                  })}
              </div>
            </Card>
          </div>
        </Col>
      );
    });

  return (
    <div className="h-full w-full flex flex-col">
      <Modal
        title="Chọn điều kiện biểu đồ"
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          formModal.resetFields();
        }}
        okButtonProps={{ hidden: true }}
        cancelButtonProps={{ hidden: true }}
      >
        <Form layout="vertical" requiredMark={false} form={formModal} onFinish={handleSubmitFormModal}>
          <div className="flex flex-row w-full gap-5 justify-center">
            <div className="flex flex-col gap-2 w-full">
              <Form.Item
                name="metric"
                label={
                  <Typography.Text>
                    Chọn Metrics<span className="text-red-700">*</span>
                  </Typography.Text>
                }
                rules={[{ required: true, message: 'Vui lòng chọn metrics' }]}
                initialValue={1}
              >
                <CustomSelect options={dataToOptionSelect(dataMetrics || [], 'name', 'id')} />
              </Form.Item>
            </div>

            <div className="flex flex-col gap-2 w-full">
              <Form.Item
                name="dimension"
                label={
                  <Typography.Text>
                    Chọn Dimensions <span className="text-red-700">*</span>
                  </Typography.Text>
                }
                rules={[{ required: true, message: 'Vui lòng chọn dimensions' }]}
                initialValue={-1}
              >
                <CustomSelect
                  options={[
                    { label: 'Tất cả', value: -1 },
                    ...dataToOptionSelect(dataDimensions?.filter((item) => item.id !== 1) || [], 'name', 'id'),
                  ]}
                />
              </Form.Item>
            </div>
          </div>
          <div className="flex justify-end">
            <Button type="primary" htmlType="submit">
              Ok
            </Button>
          </div>
        </Form>
      </Modal>
      <Row gutter={[16, 16]}>
        {isLoading ? (
          <div className="flex items-center justify-center w-full h-40">
            <Spin size="large" />
          </div>
        ) : (
          renderGraphical()
        )}
      </Row>
    </div>
  );
}
